import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Common_Images_Transport from "../../../common/common_imges_transport/Common_Images_Transport";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchMasterData } from "../../../../redux/actions/masterdataActions";

const HeroSection = () => {

  const dispatch = useDispatch();
  const { horoscopePages } = useSelector(
    (state) => state?.masterdata || []
  );

  useEffect(() => {
    dispatch(fetchMasterData());
  }, [dispatch]);


  const TodayPanchang = horoscopePages?.find((item) => item?.page_name === "panchang")
  const Numeriology = horoscopePages?.find((item) => item?.page_name === "numerology")
  const NakshatrasConstellations = horoscopePages?.find((item) => item?.page_name === "nakshatras-constellations")


  // Slick Slider settings
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1280, // Large Screens
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024, // Laptops
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // Mobile Phones
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  };



  return (
    <section className="gi-category bg-[#f1f1f1] py-3 overflow-hidden">
      <div className="container mx-auto max-w-screen-xl">
        <div className="w-full px-6 lg:px-8">
          <Slider {...settings} className="flex items-center gap-4 lg:gap-6 z-0">
            {/* Chat with Astro */}
            <div className="px-2 py-5">
              <Link to="/astrologer-list">
                <div className="p-6 flex flex-col items-center justify-center bg-white">
                  <img
                    src={Common_Images_Transport?.Chat_astro}
                    className="w-full max-w-[70px] object-contain"
                    alt="Chat with Astro"
                  />
                  <h4 className="mt-3 text-center text-sm font-semibold text-gray-800">
                    Chat with Astro
                  </h4>
                </div>
              </Link>
            </div>

            {/* Chat with Numerology */}
            <div className="px-2 py-5">
              <Link to={`/page/${Numeriology?.slug}`}>
                <div className="p-6 flex flex-col items-center justify-center bg-white">
                  <img
                    src={Common_Images_Transport?.chat_numerology}
                    className="w-full max-w-[70px] object-contain"
                    alt="Chat with Numerology"
                  />
                  <h4 className="mt-3 text-center text-sm font-semibold text-gray-800">
                    Chat with Numerology
                  </h4>
                </div>
              </Link>
            </div>

            {/* Talk with Counsellor */}
            <div className="px-2 py-5">
              <Link to={`/page/${NakshatrasConstellations?.slug}`}>
                <div className="relative">
                  {/* Move the span here */}
                  <div className="p-6 flex flex-col items-center justify-center bg-white">
                    <img
                      src={Common_Images_Transport?.chat_numerology}
                      className="w-full max-w-[70px] object-contain"
                      alt="Chat with Numerology"
                    />
                    <h4 className="mt-3 text-center text-sm font-semibold text-gray-800">
                      Talk with Counsellor
                    </h4>
                  </div>
                </div>
              </Link>
            </div>


            {/* Festival this Year */}
            {/* <div className="px-2 py-5">
              <Link to="/festivals">
                <div className="p-6 flex flex-col items-center justify-center bg-white">
                  <img
                    src={Common_Images_Transport?.festival_year}
                    className="w-full max-w-[70px] object-contain"
                    alt="Festival this Year"
                  />
                  <h4 className="mt-3 text-center text-sm font-semibold text-gray-800">
                    Festival this Year
                  </h4>
                </div>
              </Link>
            </div> */}

            {/* Panchang */}
            <div className="px-2 py-5">
              <Link to={`/page/${TodayPanchang?.slug}`}>
                <div className="p-6 flex flex-col items-center justify-center bg-white">
                  <img
                    src={Common_Images_Transport?.punchang}
                    className="w-full max-w-[70px] object-contain"
                    alt="Panchang"
                  />
                  <h4 className="mt-3 text-center text-sm font-semibold text-gray-800">
                    Panchang
                  </h4>
                </div>
              </Link>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
